<template>
  <div class="copy-wrap">
    <resize-container :tabShow="tabShow">
      <div class="tree-content box" v-show="tabShow" slot="left">
        <tab-tree :data="viewTreeData" :checkbox="true" @tabTreeDefault="tabTreeDefault" @change="tabTreeChange" @changeCompany="changeCompany"></tab-tree>
      </div>
      <div class="right-content">
        <div class="search-box box">
          <time-search ref="timeSearch" :control="{data:timeData}" @timeControlChange="timeControlChange" @timeControlClick="TimeControlClick" :showExportBtn="true" @exportExc="bindExportExc">
          </time-search>
        </div>
        <div class="table-content box" v-loading="loading">
          <nk-table id="table" :showPage="true" :page="page" :data="tableData" :noDataTitle="'该时间段暂无数据'" :columns="columns" :border="false" :rowselect="true" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
            <el-table-column slot="total" fixed="left" label="合计" width="110" align="center">
              <template slot-scope="scope">
                <span style="color:#0197ee">{{scope.row.total}}</span>
              </template>
            </el-table-column>
          </nk-table>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
import {
  findDataByParam,
  dateToColumns,
  toPage,
  exportExcel,
} from '@/utils/index.js'
import api from '@common/api/index.js'
import TabTree from '@/components/common/TabTree.vue'
import TimeSearch from '@/components/common/TimeSearch.vue'
import NkTable from '@/components/common/NkTable'
import dateTool from '@/utils/dateTool'
import ResizeContainer from '@/components/common/resizeContainer.vue'
import { isNull } from 'util'
let allTimeData = [
  {
    type: 'day',
    label: '日',
  },
  {
    type: 'month',
    label: '月',
  },
  {
    type: 'year',
    label: '年',
  },
]
export default {
  components: { TabTree, TimeSearch, NkTable, ResizeContainer },
  data () {
    return {
      viewTreeData: [],
      tabShow: true,
      timeData: allTimeData,
      selectedDate: {},
      dataType: '1',
      tableData: [],
      page: {
        pageSizes: [10, 20, 50, 100, 500, 1000], //每页显示条目个数
        size: 10,
        total: 0,
        pageIndex: 1,
      },
      columns: [
        {
          prop: 'value',
          label: '计量点名称',
          show: true,
          width: '',
          align: 'left',
        },
        {
          prop: 'preTimeRead',
          label: '上期读数',
          show: true,
          width: '',
          align: 'right',
        },
        {
          prop: 'curTimeRead',
          label: '本期读数',
          show: true,
          width: '',
          align: 'right',
        },
        {
          prop: 'curUse',
          label: '本期用量',
          show: true,
          width: '',
          align: 'right',
        },
        {
          prop: 'amount',
          label: '金额(元)',
          show: true,
          width: '',
          align: 'right',
        },
      ],
      checkedNodeKeys: [],
      energyType: 1,
      loading: false,
      treeNodes: [],

      //   bottomTableData: [],
    }
  },
  created () { },
  methods: {
    /* 切换公司树 */
    changeCompany (companyId) {
      let vm = this
      api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(companyId, '/report/electricityCb', null)
        .then((res) => {
          const viewTreeData = findDataByParam('viewTree', true, res.data)
          vm.viewTreeData = viewTreeData
        })
    },
    tabTreeDefault (node) {
      let vm = this
      vm.checkedNodes = JSON.parse(JSON.stringify([node]))
      let measureIdS = vm.deep([node])
      vm.treeNodes = measureIdS
      vm.checkedNodeKeys = []
      measureIdS.forEach((item) => {
        vm.checkedNodeKeys.push(item.measureId)
      })
      let time = new Date()
      let startTime = dateTool.format(time, 'yyyy-MM-dd ') + '00:00:00'
      time.setDate(time.getDate() + 1)
      let endTime = dateTool.format(time, 'yyyy-MM-dd') + ' 00:00:00'
      vm.selectedDate = {
        dataType: '1',
        dateType: 'day',
        endTime: endTime,
        startTime: startTime,
      }
      vm.TimeControlClick(vm.selectedDate)
    },
    /**
     * 树转数组扁平化结构
     * 深度优先遍历  堆栈  后进先出
     */
    deep (node) {
      let stack = node,
        data = []
      while (stack.length != 0) {
        let pop = stack.pop()
        data.push({
          id: pop.id,
          name: pop.measureName,
          parentId: pop.parentId,
          measureId: pop.measureId,
        })
        let children = pop.children
        if (children) {
          for (let i = children.length - 1; i >= 0; i--) {
            stack.push(children[i])
          }
        }
      }
      return data
    },
    tabTreeChange (nodes, ids, data) {
      let vm = this
      let dataType = vm.dataType
      vm.checkedNodes = JSON.parse(JSON.stringify(nodes))
      vm.treeNodes = JSON.parse(JSON.stringify(data))
      vm.checkedNodeKeys = []
      vm.treeNodes.forEach((item) => {
        vm.checkedNodeKeys.push(item.measureId)
        item['name'] = item.measureName
      })
      vm.getTableData(1)
    },
    timeControlChange () { },
    //查询事件
    TimeControlClick (e) {
      let vm = this
      vm.selectedDate = e
      vm.selectedDate.dataType = vm.dataType
      this.getTableData(1)
    },

    /**
     * 获取列表数据
     */
    getTableData (pageIndex) {
      let vm = this
      let pointCode = '100229'
      let pointCode_ = '229'
      let energyType = '1'
      vm.loading = true
      let checkedNodeKeys = vm.checkedNodeKeys
      if (checkedNodeKeys.length == 0) {
        vm.$message.warning('请选择查询的计量点！')
        vm.tableData = []
      }
      vm.page.pageIndex = pageIndex
      let page = toPage(vm.treeNodes, pageIndex, vm.page.size)
      let measureIds = page.arr
      let measures = measureIds.map((v) => {
        return {
          measureId: v.measureId,
          pointCode: pointCode,
          pointNumber: '0',
        }
      })
      let measures_ = measureIds.map((v) => {
        return {
          measureId: v.measureId,
          pointCode: pointCode_,
          pointNumber: '0',
        }
      })
      let startTime = vm.selectedDate.startTime
      let endTime = vm.selectedDate.endTime
      let use, mony, lastnum, nownum
      let segments = null,
        pricingMode = null,
        limit = '1'

      use = vm.$api.quantity.getQuantity2(
        JSON.stringify(measures),
        startTime,
        endTime,
        segments
      )
      lastnum = vm.$api.measuringRaw.getMeasuringRawValue2(
        measures_,
        startTime,
        endTime,
        '0',
        limit
      ) //上期期读数
      nownum = vm.$api.measuringRaw.getMeasuringRawValue2(
        measures_,
        startTime,
        endTime,
        '1',
        limit
      ) //本期读数

      if (vm.selectedDate.dateType == 'day') {
        mony = vm.$api.cost.getSpentMoneyDay3(
          measures,
          startTime,
          endTime,
          segments,
          energyType,
          pricingMode
        ) //电费
      } else if (this.selectedDate.dateType == 'month') {
        mony = this.$api.cost.getSpentMoneyMonth2(
          measures,
          startTime,
          endTime,
          energyType,
          pricingMode
        )
      } else {
        mony = this.$api.cost.getSpentMoneyYear2(
          measures,
          startTime,
          endTime,
          energyType,
          pricingMode
        )
      }
      let needarr = this.nodeData
      Promise.all([use, nownum, lastnum, mony]).then((res) => {
        let curuse = vm.ordinaryData(res)
        vm.loading = false
        vm.page.pageIndex = pageIndex
        vm.page.total = page.total
        vm.tableData = JSON.parse(JSON.stringify(curuse))
      })
    },
    ordinaryData (arr) {
      let vm = this
      let page = toPage(vm.treeNodes, vm.page.pageIndex, vm.page.size)
      let needarr = page.arr
      needarr.forEach((v, i) => {
        arr[0].data.forEach((item, y) => {
          if (v.measureId == item.measureId) {
            v.value = v.name
            if (vm.selectedDate.dateType == 'day') {
              v.amount =
                arr[3].data[y].data[0][0].value != undefined
                  ? arr[3].data[y].data[0][0].value.toFixed(2)
                  : '-'
            } else {
              v.amount =
                arr[3].data[y].data[0].value != undefined
                  ? arr[3].data[y].data[0].value.toFixed(2)
                  : '-'
            }
            v.curUse = isNull(item.value) ? '-' : item.value.toFixed(2)
            v.preTimeRead =
              arr[2].data[y].data.data.length == 0
                ? '-'
                : arr[2].data[y].data.data[0].value.toFixed(2)
            v.curTimeRead =
              arr[1].data[y].data.data.length == 0
                ? '-'
                : arr[1].data[y].data.data[0].value.toFixed(2)
          }
        })
      })
      return needarr
    },
    bindExportExc () {
      //表格导出
      let name = '电费抄表'
      exportExcel('table', name, this.selectedDate)
    },
    handleCurrentChange (val) {
      this.getTableData(val)
    },
    handleSizeChange (val) {
      this.page.size = val
      this.getTableData(1)
    },
  },
}
</script>

<style lang="scss" scoped>
.copy-wrap {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  display: flex;
}
.tree-content {
  width: 100%;
  margin-right: 14px;
}
.right-content {
  display: flex;
  flex-flow: column;
  width: 100%;
  height: 100%;
}
.search-box {
  height: 36px;
}
.table-content {
  width: 100%;
  margin-top: 14px;
  padding: 10px;
  box-sizing: border-box;
}
.bottom {
  width: 100%;
  height: 100%;
  // display: flex;
  // flex:1;
  // flex-flow: column;
}
</style>